import React, { useEffect, useState, useRef, useImperativeHandle } from 'react';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import gsap from 'gsap';
import * as ScrollMagic from 'scrollmagic-with-ssr';
import './style.scss';
import temp from '../../temp/config';
import { getPrefixField, sendDmp, convertStylesStringToObject, isMobileFun, createFilePath } from '../../utils/obj-utils';
import LazyLoad from 'react-lazyload';
export default function index({ fields, eventRef }) {
  const holderImg = <img alt="广汽本田" src={createFilePath('/common/placeholder.jpg')} />;
  const mobileAppRef = useRef(null);
  // const imgRef = useRef(null);
  const isMobile = isMobileFun();
  const container_style = fields[getPrefixField('container_style', isMobile)]?.value;
  const html = fields[getPrefixField('html', isMobile)]?.value;
  const [data, _] = useState({
    container_style,
    html
  });

  useImperativeHandle(eventRef, () => {
    return {
      sendEvent
    };
  });

  const sendEvent = () => {
    sendDmp(fields?.sectionDmp);
  };

  // useEffect(() => {
  //   if (!data) {
  //     return;
  //   }
  //   const mobileAppTimeline = gsap.timeline({ pause: true });
  //   if (!data.isMobile) {
  //     mobileAppTimeline.fromTo(imgRef.current, { x: '30%', opacity: 0 }, { x: '0', opacity: 1 });
  //   } else {
  //     mobileAppTimeline.fromTo(imgRef.current, { x: '100%', opacity: 0 }, { x: '0', opacity: 1 });
  //   }
  //   const controller = new ScrollMagic.Controller();
  //   const mobileAppScene = new ScrollMagic.Scene({
  //     triggerElement: mobileAppRef.current,
  //     triggerHook: 'onEnter',
  //     duration: data.isMobile ? document.documentElement.clientHeight : '70%'
  //   })
  //     .on('progress', function (event) {
  //       mobileAppTimeline.progress(event.progress);
  //     })
  //     .setTween(mobileAppTimeline)
  //     .addTo(controller);
  //   return () => {
  //     mobileAppTimeline.kill();
  //     mobileAppScene.remove();
  //     mobileAppScene.destroy();
  //     controller.destroy();
  //   };
  // }, [data]);

  return (
    <LazyLoad placeholder={holderImg}>
      <section className="container_mobileApp" ref={mobileAppRef}>
        {data && (
          <div
            className="mobileApp"
            style={convertStylesStringToObject(data.container_style)}
            dangerouslySetInnerHTML={{ __html: data.html?.replaceHtml() }}
          ></div>
        )}
      </section>
    </LazyLoad>
  );
}
